import { KNOB_CONFIGURATION } from '@/config/knobConfig';
import { ENCLOSURE_MATERIALS } from '@/config/enclosureConfig';
import { LED_MATERIALS } from '@/config/ledConfig';

// Configuration interfaces
export interface ConfigurationData {
  knobColor: string;
  ledColor: string;
}

export interface ShopifyConfigurationData {
  'Knob Color': string;
  'LED Color': string;
}

// Helper functions to get display names
export const getEnclosureDisplayName = (id: string): string => {
  const material = ENCLOSURE_MATERIALS.find(m => m.id === id);
  return material?.displayName || id;
};

export const getKnobTypeDisplayName = (id: string): string => {
  const knobType = KNOB_CONFIGURATION.find(k => k.id === id);
  return knobType?.displayName || id;
};

export const getKnobMaterialDisplayName = (knobTypeId: string, materialId: string): string => {
  const knobType = KNOB_CONFIGURATION.find(k => k.id === knobTypeId);
  if (!knobType) return materialId;
  
  const material = knobType.materials.find(m => m.id === materialId);
  return material?.displayName || materialId;
};

export const getLEDDisplayName = (id: string): string => {
  const led = LED_MATERIALS.find(l => l.id === id);
  return led?.displayName || id;
};

// Main function to convert configuration to display data
export const convertToDisplayConfiguration = (
  enclosureMaterial: string,
  knobType: string,
  knobMaterial: string,
  ledMaterial: string
): ConfigurationData => {
  return {
    knobColor: getKnobMaterialDisplayName(knobType, knobMaterial),
    ledColor: getLEDDisplayName(ledMaterial)
  };
};

// Convert to Shopify format with line item properties
export const convertToShopifyFormat = (config: ConfigurationData): ShopifyConfigurationData => {
  return {
    'Knob Color': config.knobColor,
    'LED Color': config.ledColor
  };
}; 